import { Box, styled } from '@material-ui/core';

export const Container = styled(Box)({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  flexDirection: 'column'
});

export const TabsContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 99,
  // STabs hardcodes its root wrapper to `width: min-content`, which defeats the
  // `variant="fullWidth"` and leaves empty space on the right. Force it to fill
  // so the Categories/Filters tabs span the whole pill. (CSS !important beats
  // the inline style.)
  '& > div': {
    width: '100% !important'
  }
}));

export const HomeIconContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',

  '&:hover': {
    '& path': {
      fill: `${theme.palette.primary.main} !important`
    }
  }
}));
